<template>
  <div>
    <project-view v-if="filter.type === 1" :list="list" :type="getType" :headers="headers"></project-view>
    <activity-view v-if="filter.type === 2" :list="list" :type="getType" :headers="headers"></activity-view>
    <employee-view v-if="filter.type === 3" :list="list" :type="getType" :headers="headers"></employee-view>
  </div>
</template>
<script>
export default {
  props: ['list', 'filter', 'reportFilter', 'headers'],
  components: {
    'project-view': () => import('./ProjectView'),
    'activity-view': () => import('./ActivityView'),
    'employee-view': () => import('./EmployeeView')
  },
  computed: {
    getType () {
      if (this.reportFilter.showonlysum && !this.reportFilter.showestimation) return 'sum'
      else if (!this.reportFilter.showonlysum && this.reportFilter.showestimation) return 'estimation'
      else if (this.reportFilter.showestimation && this.reportFilter.showonlysum) return 'sum_both'
      else return 'all'
    }
  }
}
</script>
<style>
.report tbody td {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  height: 38px !important;
}
</style>
